import {useCallback, useEffect, useRef, useState} from 'react';

import type {LightboxSlide} from '../../components/Lightbox/types';
import type {ShowParams} from './types';

import {openUrlInANewTab} from '../../../../utils/openUrlInANewTab';
import {storageTokenManager} from '../../../../utils/storageToken';
import {getSlideType} from '../../components/Lightbox/utils';

export const useController = () => {
  const [showParams, setShowParams] = useState<ShowParams>({
    slides: [],
  });

  const [isOpen, setIsOpen] = useState(false);

  const hideTimeout = useRef(0);

  useEffect(() => {
    clearTimeout(hideTimeout.current);
  }, []);

  const show = useCallback((params: ShowParams) => {
    const slides = params.slides.slice();

    const htmlContentSlides: LightboxSlide[] = [];

    const shouldSplitHtmlSlides = true;

    if (shouldSplitHtmlSlides) {
      slides.forEach((slide, index) => {
        const type = slide.type || getSlideType(slide.src);

        if (type === 'htmlContent') {
          htmlContentSlides.push(slide);
          slides.splice(index, 1);
        }
      });
    }

    htmlContentSlides.forEach(slide => {
      openUrlInANewTab(slide.src);
    });

    const isAnyLinkExpired = slides.some(slide =>
      storageTokenManager.checkIsUrlExpired(slide.src),
    );

    if (!slides.length || isAnyLinkExpired) {
      return;
    }

    clearTimeout(hideTimeout.current);
    setShowParams(params);
    setIsOpen(true);
  }, []);

  const hide = useCallback(() => {
    setIsOpen(false);

    hideTimeout.current = +setTimeout(() => {
      setShowParams({
        slides: [],
        startIndex: 0,
      });
    }, 300);
  }, []);

  return {
    hide,
    isOpen,
    show,
    showParams,
  };
};
